import React from 'react';
import { IFullPageLayoutProps } from './IFullPageLayoutProps';
import { navigateTo } from '../../routing/Navigation';
import { Breadcrumbs } from '@orderly/morrisons-component-library';
import styles from './FullPageLayout.module.scss';

function FullPageLayout({
  homeRoute = '/home',
  heading,
  children,
  breadcrumbs,
  headerAdditionalContent,
  showHeading = true,
  headerPillContent,
}: IFullPageLayoutProps): JSX.Element {
  return (
    <div className={styles.container}>
      {
        breadcrumbs.length > 0 &&
        <Breadcrumbs
          onHomeClick={() => navigateTo(homeRoute)}
          onRedirect={navigateTo}
          segments={breadcrumbs.map((crumb) => { return { ...crumb, text: crumb.text.toUpperCase() }; })}
          className={styles.breadcrumbs}
        />
      }
      {
        showHeading &&
        <div className={styles.headerContainer}>
          <div className={styles.header}>
            <h3>{heading.toUpperCase()}</h3>
            {headerPillContent}
          </div>
          {
            headerAdditionalContent
          }
        </div>
      }
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
}

export default FullPageLayout;
